export default function(value, maxLength) {
  if (maxLength && value && value.length > maxLength) {
    return value
      .toString()
      .slice(0, maxLength)
      .concat('...')
  }
  return value
}
